(function($) {
  window.addEventListener('load', function() {

    let sliders = document.querySelectorAll('.slick-slider');

    sliders.forEach(function(element) {
      if (element.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.contains('frame-type-1-column-container')) {
        $(element).slick();
      } else {
        $(element).slick({
          variableWidth: true,
          centerMode: true,
          slideToShow: 1,
          slidesToScroll: 1
        });
      }
    });
  });
})(jQuery);
